<template>
  <div class="home">
    <popup v-if="noteshow" id="pop-up" />
    <Header id="header" />
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <p id="diplayId">
      ID : {{ display }}
    </p>
    <!--<button class="home-buttons" @click="publicViewTrigger">
      Browse
    </button>-->
    <div id="display-contents">
      <projectList v-if="!publicView" />
      <publicprojectList v-if="publicView" />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'; // mapState,
import firebase from '@/firebase/firestore';

import Footer from '@/components/footer.vue';
import Header from '@/components/header.vue';

import projectList from '@/components/projectList.vue';
import publicprojectList from '@/components/publicprojectList.vue';
import popup from '@/components/notePopUp.vue';

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    projectList,
    publicprojectList,
    popup,
  },
  data() {
    return {
      display: firebase.auth().currentUser.email,
      publicView: false,
    };
  },
  computed: {
    user() {
      return this.store.getters.user;
    },
    ...mapGetters(['noteshow']),
  },
  methods: {
    publicViewTrigger(){
      if(this.publicView == false){
        this.publicView = true;
      }else{
        this.publicView = false
      }    
    },
  },
};
</script>

<style>
@media screen and (max-width:768px){
  /*画面サイズが480pxからはここを読み込む*/
  #diplayId{
    font-size: 0.5em;
  }
  .home-buttons{
    height: 20px;
  }
}

@media screen and (min-width:768px) and ( max-width:1024px) {
  /*画面サイズが768pxから1024pxまではここを読み込む*/
  .home-buttons{
      height: 20px;
    }
}

@media screen and (min-width:1024px) {
  /*画面サイズが1024pxからはここを読み込む*/
  .home-buttons{
    height: 30px;
  }
}
.home{
  padding: 10px;
}
#display-contents{
  margin-top: 30px;
}

.home-buttons{
  border: solid #42b983 1px;
  margin-left: 5px;
}
#pop-up{
  background:rgba(8, 8, 8, 0.9);
  z-index: 100;
}

</style>
